export default __webpack_public_path__ + "static/media/icon-consumption-sqft.0dc2cb11.svg";